export default __webpack_public_path__ + "static/media/VC kanban.b6339d14.png";